package com.milta.feature.aicredit.presentation

import com.milta.core.localization.AiCreditStrings
import com.milta.feature.aicredit.domain.entity.AiCredit
import com.milta.feature.aicredit.domain.entity.AiCreditAction
import com.milta.feature.aicredit.domain.entity.AiCreditOutcome
import com.milta.feature.optimizationquota.domain.entity.OptimizationQuota
import com.milta.feature.optimizationquota.presentation.OptimizationQuotaFormat
import com.milta.feature.optimizationquota.presentation.fillPlaceholders

/**
 * MIL-98 — texts composed from [AiCreditStrings], shared by the mobile screens and the web
 * dashboard (Compose HTML can't use the mobile composables, but can use these).
 */

/** "62 %" */
fun AiCreditStrings.percent(value: Int): String = percentValue.fillPlaceholders("percent" to value)

/** "Crédit IA épuisé — remise à zéro le 14/11." (M1). */
fun AiCreditStrings.menuExhausted(credit: AiCredit): String =
    menuExhaustedTitle.fillPlaceholders("date" to OptimizationQuotaFormat.dayMonth(credit.resetAt))

/**
 * Profile row value (M3): "7/20 · IA 17 %", only the AI part while the optimization counter is
 * unknown, null when neither is.
 */
fun AiCreditStrings.profileUsageValue(quota: OptimizationQuota?, credit: AiCredit?): String? = when {
    credit == null -> quota?.let { "${it.remaining}/${it.limit}" }
    quota == null -> profileValueAiOnly.fillPlaceholders("percent" to credit.remainingPercent)
    else -> profileValue.fillPlaceholders("optimizations" to "${quota.remaining}/${quota.limit}", "percent" to credit.remainingPercent)
}

fun AiCreditStrings.actionLabel(action: AiCreditAction?): String = when (action) {
    null -> "—"
    AiCreditAction.ScanDeliveryList -> actionScanDeliveryList
    AiCreditAction.ScanPackageLabel -> actionScanPackageLabel
    AiCreditAction.ImportPdf -> actionImportPdf
    AiCreditAction.ImportUnstructured -> actionImportUnstructured
    AiCreditAction.SpreadsheetMapping -> actionSpreadsheetMapping
}

fun AiCreditStrings.outcomeLabel(outcome: AiCreditOutcome): String = when (outcome) {
    AiCreditOutcome.Success -> outcomeSuccess
    AiCreditOutcome.Failed -> outcomeFailed
    AiCreditOutcome.Unreadable -> outcomeUnreadable
}

/** "−1,2 %" share of the credit used by one call (R1: a percentage, never euros). */
fun AiCreditStrings.share(creditPercent: Double): String = AiCreditFormat.share(creditPercent, percentValue, decimalSeparator)

/** "3,72 €" — Admin. */
fun AiCreditStrings.eur(value: Double, decimals: Int = 2): String = AiCreditFormat.eur(value, decimals, decimalSeparator)
